import React, {Component} from "react";
import PropTypes from "prop-types";

class TakemoneyItems extends Component {
	static defaultProps = {
		title : ''
	};

	static propTypes = {
		title : PropTypes.string.isRequired,
	};

	render() {
		return (
			<div className="table cash-in-out__table">
				<div className="table__row header">
					<div className="table__column payment-type">Способ выплаты</div>
					<div className="table__column comission">Комиссия</div>
					<div className="table__column in-processing">В обработке</div>
					<div className="table__column min-sum">Мин. сумма</div>
					<div className="table__column actions">&nbsp;</div>
				</div>

				<div className="table__row subheader">
					<div className="table__column payment-type">{this.props.title}</div>
					<div className="table__column comission"></div>
					<div className="table__column in-processing"></div>
					<div className="table__column min-sum"></div>
					<div className="table__column actions"></div>
				</div>

				{this.props.children}
			</div>
		);
	}
}

export default TakemoneyItems;


// WEBPACK FOOTER //
// ./src/app/pages/User/Takemoney/TakemoneyItems.js